<template>
  <div class="wrap">
    <Level4Search />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import breadcrumbs from '@/modules/core/mixins/breadcrumbs';
import Level4Search from '../components/Level4Search.vue';

export default {
  name: 'Level4',
  mixins: [breadcrumbs],
  created() {
    this.routeBreadcrumbs();
  },
  components: {
    Level4Search,
  },
  computed: {
    ...mapGetters({
      categoriesPath: 'level4/categoriesPath',
    }),
  },
};
</script>
